import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setCohortCollaborators } from 'Workspace/Cohorts/store/actions';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { cohortId } = action;

  const workspaceCohortAccountSummary = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_COLLABORATOR_SUMMARY,
    cohortId,
  });

  if (workspaceCohortAccountSummary.type === constants.RTM_WORKSPACE_COHORT_COLLABORATOR_SUMMARY_OK) {
    const cohortCollaborators = workspaceCohortAccountSummary.response.collaborators;
    yield put(setCohortCollaborators(cohortId, cohortCollaborators));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceCohortAccountSummaryFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_COLLABORATOR_SUMMARY, catchErrors, sendRequest, connection);
}
